import {AppLayoutConfigInterface} from '../interfaces/app-layout-config.interface';

export function prepareAppLayoutConfig(data): AppLayoutConfigInterface {
  return {
    isSidebarHidden: data?.isSidebarHidden,
    isHeaderShortened: data?.isHeaderShortened,
    isNewNotificationsHidden: data?.isNewNotificationsHidden,
  };
}
